import { Navigate, useLocation } from 'react-router-dom'

const OAUTH_CALLBACK_KEYS = [
  'authdb_linked', 'authdb_error',
  'github_linked', 'github_error',
  'gitlab_linked', 'gitlab_error',
  'google_drive_linked', 'google_drive_error',
  'slack_linked', 'slack_error',
  'dynamics_linked', 'dynamics_error',
  'powerapps_linked', 'powerapps_error',
]

function preservingTarget(pathname: string, search: string, hash: string) {
  return { pathname, search, hash }
}

export function LegacyProfileRedirect() {
  const { search, hash } = useLocation()
  return <Navigate replace to={preservingTarget('/account/profile', search, hash)} />
}

export function LegacySettingsRedirect() {
  const { search, hash } = useLocation()
  const params = new URLSearchParams(search)
  let pathname = OAUTH_CALLBACK_KEYS.some((key) => params.has(key))
    ? '/account/connections'
    : '/account/appearance'

  if (pathname === '/account/appearance') {
    if (hash === '#notifications') pathname = '/account/notifications'
    if (hash === '#api-access' || hash === '#api') pathname = '/account/api-access'
    if (hash === '#terminal' || hash === '#browser' || hash === '#tts') pathname = '/account/workspace'
    if (hash === '#connections' || hash === '#integrations') pathname = '/account/connections'
  }

  return <Navigate replace to={preservingTarget(pathname, search, hash)} />
}
